import Vue from 'vue'

Vue.directive('uppercase', {
  bind(el, _, vnode) {
    el.addEventListener('keyup', e => {
      e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
  },
})

Vue.directive('trim', {
  bind(el, _, vnode) {
    el.addEventListener('keyup', e => {
      e.target.value = e.target.value.trim()
      vnode.componentInstance.$emit('input', e.target.value.trim())
    })
  },
})
